@use "sass:color";
@use "../../../styles/variables.scss" as *;
@use "../../../styles/typography.scss" as *;

.claimableAuthenticatorV2 {
  min-height: 100vh;
  background: $white;
  font-family: $font-family-body;
}

.authLayout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.authLayoutHeader {
  padding: $spacing-lg;
  display: flex;
  justify-content: center;

  @media (min-width: $auth-layout-breakpoint) {
    justify-content: center;
    padding: $spacing-xl $spacing-2xl;
  }
}

.logo {
  height: 22px;
}

.authLayoutContent {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 $spacing-lg;

  @media (min-width: $auth-layout-breakpoint) {
    padding: 0 40px;
  }
}

.authLayoutInner {
  display: flex;
  flex-direction: column;
  gap: $spacing-xl;
  align-items: center;
  width: 100%;

  @media (min-width: $auth-layout-breakpoint) {
    flex-direction: row;
    gap: 40px;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1320px;
  }
}

.formContainer {
  flex: 0 0 auto;
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  background: $white;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;

  @media (min-width: $auth-layout-breakpoint) {
    margin: 0;
    flex: 1 1 430px;
    min-width: 430px;
    max-width: 640px;
    width: auto;
    padding: 32px;
  }
}

.socialProofWrapper {
  display: none;

  @media (min-width: $auth-layout-breakpoint) {
    display: flex;
    flex: 1 1 430px;
    min-width: 430px;
    max-width: 640px;
  }
}

.socialProofPanel {
  position: relative;
  padding: 48px;
  border-radius: 24px;
  background: linear-gradient(135deg, #dddbed 48.77%, #b9b3e0 99.81%);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  box-shadow: none;
}

.socialProofDecoration {
  position: absolute;
  top: -40px;
  left: -80px;
  right: -80px;
  z-index: 0;
  pointer-events: none;
  width: auto;
  min-width: calc(100% + 160px);
}

.socialProofBackground {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.socialProofCard {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  border-radius: 20px;
  box-shadow: none;
}

.socialProofImageContainer {
  width: 100%;
  aspect-ratio: 435 / 297;
  overflow: hidden;
}

.socialProofImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 8px;
}

.testimonialContent {
  padding: 20px 24px;
  text-align: center;
  height: 160px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.quoteText {
  font-family: $font-family-body;
  font-size: 15px;
  font-weight: 400;
  line-height: 145%;
  color: $neutral-grey-1000;
  font-style: italic;
  margin: 0 0 $spacing-sm;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.testimonialAttribution {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.testimonialName {
  @include text-style("text-md-medium");
  color: $neutral-grey-1000;
  margin: 0;
}

.testimonialDetail {
  @include text-style("text-sm");
  color: $neutral-grey-800;
  margin: 0;
}

.testimonialResult {
  @include text-style("text-xs");
  color: $neutral-grey-1000;
  text-align: center;
  margin: 0;
  padding-top: $spacing-md;
  height: 32px;
}

.authLayoutFooter {
  padding: $spacing-lg;
  text-align: center;
}

.copyright {
  @include text-style("text-xs");
  color: $neutral-grey-700;
}

.formLogo {
  height: 22px;
  display: block;
  margin: 0 auto $spacing-xl;
}

.formEyebrow {
  font-family: $font-family-body;
  font-size: 17px;
  font-weight: 400;
  line-height: 100%;
  color: $neutral-grey-1000;
  margin: 0 0 $spacing-lg;
  text-align: center;
}

.formTitle {
  font-family: $font-family-brand;
  font-size: 32px;
  font-weight: 700;
  line-height: 110%;
  color: $neutral-grey-1000;
  margin: 0 0 $spacing-xl;
  text-align: center;
}

.formSubtitle {
  font-family: $font-family-body;
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  color: $neutral-grey-700;
  margin: 0 0 $spacing-2xl;
  text-align: center;
}

.primaryButton {
  width: 100%;
  padding: 24px 0;
  margin-top: $spacing-md;
  background-color: $almost-black;
  color: $light-volt;
  border: none;
  border-radius: 9999px;
  font-family: $font-family-brand;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    background-color: $light-volt;
    color: $almost-black;
  }

  &:disabled {
    background-color: $light-gray;
    color: $gray;
    cursor: not-allowed;
  }
}

.secondaryButton {
  width: 100%;
  padding: 24px 0;
  background-color: $white;
  color: $almost-black;
  border: 1px solid $almost-black;
  border-radius: 9999px;
  font-family: $font-family-brand;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    background-color: $light-volt;
    border-color: $light-volt;
  }

  &:disabled {
    background-color: $light-gray;
    color: $gray;
    border-color: $light-gray;
    cursor: not-allowed;
  }
}

.form {
  display: flex;
  flex-direction: column;
  gap: $spacing-xl;
}

.inputGroup {
  display: flex;
  flex-direction: column;
  gap: $spacing-xs;
}

.textInput {
  border: 1px solid $beige;
  border-radius: 8px;
  height: 48px;
  padding: 0 $spacing-lg;
  background-color: $white;
  font-size: 16px;
  font-family: $font-family-body;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    border-color: $almost-black;
    outline: none;
  }

  &:disabled {
    background-color: $white;
    color: $neutral-grey-1000;
    opacity: 1;
    cursor: text;
  }

  &::placeholder {
    color: $neutral-grey-600;
  }
}

.mantineInput {
  border: 1px solid $beige;
  border-radius: 8px;
  background-color: $white;

  &:focus,
  &:focus-within {
    border-color: $almost-black;
  }

  &:disabled {
    background-color: $white;
    color: $neutral-grey-1000;
    opacity: 1;
  }
}

.inputLabel {
  @include text-style("text-sm-medium");
  color: $neutral-grey-1000;
  display: block;
}

.inputDescription {
  @include text-style("text-xs");
  color: $neutral-grey-600;
  margin-top: $spacing-xs;
}

.passwordRequirements {
  display: flex;
  flex-wrap: wrap;
  gap: $spacing-xs $spacing-md;
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition:
    max-height 0.3s ease,
    opacity 0.2s ease,
    margin 0.3s ease;
}

.passwordRequirementsVisible {
  max-height: 60px;
  opacity: 1;
  margin: $spacing-xs 0 0;
}

.passwordRequirement {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: $neutral-grey-500;
  transition: color 0.2s ease;
}

.passwordRequirementMet {
  color: $secondary-green-1000;
}

.passwordRequirementIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: $neutral-grey-300;
  color: $white;
  font-size: 8px;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;

  .passwordRequirementMet & {
    background-color: $secondary-green-1000;
  }
}

.fieldError {
  @include text-style("text-sm");
  color: $secondary-red-1000;
}

.passwordWrapper {
  position: relative;
}

.passwordInput {
  padding-right: 48px;
}

.eyeButton {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: $neutral-grey-600;
  display: flex;

  &:hover {
    color: $neutral-grey-800;
  }
}

.checkboxLabel {
  @include text-style("text-sm");
  color: $neutral-grey-1000;

  a {
    color: $link-color;
    text-decoration: underline;
  }
}

.formError {
  @include text-style("text-sm");
  color: $secondary-red-1000;
  margin: 0;
  padding: $spacing-sm;
  background: $secondary-red-100;
  border-radius: 8px;
}

.switchAuthMode {
  @include text-style("text-md");
  text-align: center;
  margin-top: $spacing-xl;
  color: $neutral-grey-700;
}

.switchLink {
  background: none;
  border: none;
  color: $link-color;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  text-decoration: underline;
  padding: 0;

  &:hover {
    color: color.adjust($link-color, $lightness: -10%);
  }
}

.passwordFieldWrapper {
  position: relative;
}

.forgotPasswordLink {
  position: absolute;
  right: 0;
  top: 0;
  background: none;
  border: none;
  @include text-style("text-sm");
  color: $link-color;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
}

.accountVerifiedBanner {
  background-color: $status-green-background;
  color: $status-green-stroke;
  padding: $spacing-md $spacing-lg;
  font-size: 14px;
  font-weight: 500;
  border-radius: 12px;
  margin-bottom: $spacing-lg;
}

.emailCodeEntry {
  text-align: left;
  width: 100%;
}

.backButton {
  background: none;
  border: none;
  @include text-style("text-md");
  color: $neutral-grey-700;
  cursor: pointer;
  padding: 0;
  margin-bottom: $spacing-xl;
  display: block;
  text-align: left;

  &:hover {
    color: $neutral-grey-1000;
  }
}

.emailCodeHeader {
  margin-bottom: $spacing-xl;
  text-align: center;
}

.emailCodeTitle {
  font-family: $font-family-brand;
  font-size: 28px;
  font-weight: 700;
  line-height: 110%;
  color: $neutral-grey-1000;
  margin: 0 0 $spacing-xl;
}

.emailCodeDescription {
  font-family: $font-family-body;
  font-size: 16px;
  font-weight: 400;
  line-height: 160%;
  color: $neutral-grey-1000;
  margin: 0 0 $spacing-lg;

  strong {
    font-weight: 600;
    word-break: break-all;
  }
}

.emailCodeSpamNotice {
  @include text-style("text-sm");
  color: $neutral-grey-700;
  margin: 0 0 $spacing-2xl;
}

.checkmarkContainer {
  display: flex;
  justify-content: center;
  margin-bottom: $spacing-2xl;
}

.checkmarkIcon {
  font-size: 80px;
  color: $status-green-stroke;
}

.infoBox {
  background-color: $light-volt;
  border-radius: 12px;
  padding: $spacing-lg;
  text-align: left;
}

.infoBoxToggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-bottom: $spacing-sm;
}

.infoBoxTitle {
  @include text-style("text-md-medium");
  color: $neutral-grey-1000;
}

.infoBoxChevron {
  @include text-style("text-lg");
  color: $neutral-grey-700;
}

.infoBoxContent {
  @include text-style("text-sm");
  color: $neutral-grey-700;
  margin: 0 0 $spacing-md;
  line-height: 1.5;
}

.infoBoxDivider {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: $spacing-md 0;
}

.infoBoxHelp {
  @include text-style("text-sm");
  color: $neutral-grey-700;
  margin: 0;
}

.resendLink {
  background: none;
  border: none;
  @include text-style("text-sm");
  color: $link-color;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;

  &:hover {
    color: color.adjust($link-color, $lightness: -10%);
  }

  &:disabled {
    color: $neutral-grey-600;
    text-decoration: none;
    cursor: not-allowed;
  }
}

.signUpForm,
.signInForm,
.forgotPasswordForm,
.resetPasswordForm,
.forceNewPasswordForm {
  width: 100%;
}

.errorContainer {
  max-width: 36rem;
  margin-left: auto;
  margin-right: auto;
}
